import React, { useMemo } from 'react';
import { close } from 'static/icons/resizable';
import { useAppDispatch } from 'redux/hooks';
import { deleteAllRecentSearch } from 'redux/modules/Discounts/discounts';
import { ISearchDiscount } from 'interfaces/search.model';
import { Text, TextButton } from 'view/atoms';
import { SearchCard } from '../SearchCard';
import * as S from './SearchCategory.styles';

type ISearchCategoryProps = {
  title: string;
  items: ISearchDiscount[];
};

export const SearchCategory = ({ title, items }: ISearchCategoryProps) => {
  const dispatch = useAppDispatch();

  const deleteAllRecent = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(deleteAllRecentSearch());
  };

  const isRecentSearch = useMemo(
    () => title === 'Recent' || title === 'Недавние',
    [title],
  );

  return (
    <S.SearchCategory>
      <S.WrapperRecent>
        <Text kind='small1' color='gray2'>
          {title}
        </Text>
        {isRecentSearch && (
          <TextButton
            text='Delete all'
            iconSrc={close}
            onClick={deleteAllRecent}
            className='safe-to-click'
          />
        )}
      </S.WrapperRecent>

      <S.ItemBox>
        {items.map((it) => (
          <SearchCard
            {...it}
            key={it.discountId + title}
            isRecentSearch={isRecentSearch}
          />
        ))}
      </S.ItemBox>
    </S.SearchCategory>
  );
};
